import Base from '#BASE/store/userInfo/userInfo.store';
import { getterTypes, mutationTypes, actionTypes } from 'BASE/store/types';
import { storage } from 'BASE/common/util/util.storage';
import constant from 'BASE/common/lotteryConstant';
export const dailyPayType = constant.DailyPayType;
export const ContractType = constant.ContractType;

export default class extends Base {
    constructor() {
        super();
        this.state.privileges.contractPermission = [];
        this.state.privileges.haveExternalGameContract = undefined;
        this.state.privileges.externalGameDailyPayCreationAllowed = undefined;
        this.state.privileges.externalGameContractCreationAllowed = undefined;
        this.state.privileges.dailyPayCGCreationAllowed = undefined;
        this.state.privileges.sportDailyPayCreationAllowed = undefined;
        this.state.privileges.haveSportGameDailyPay = undefined;
        this.state.privileges.haveProportionalDividend = undefined;
        this.actions[actionTypes.USER_INFO_PRIVILEGES_BONUS] = async (context, payload) => {
            context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                contractCreationAllowed: undefined,
                dailyPayCreationAllowed: undefined,
                haveContract: undefined,
                haveDailyPay: undefined,
                dailyPayCGCreationAllowed: undefined,
                haveCGDailyPay: undefined,
                haveExternalGameDailyPay: undefined,
                haveExternalGameContract: undefined,
                dailyPayPermission: [],
                contractPermission: [],
                externalGameDailyPayCreationAllowed: undefined,
                externalGameContractCreationAllowed: undefined,
                sportDailyPayCreationAllowed: undefined,
                haveSportGameDailyPay: undefined,
                haveProportionalDividend: undefined,
                haveBonusWallet: undefined
            });
            if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
                try {
                    let _result = await $.post('/api/BonusPrivileges/Get');
                    let dailyPayCreationAllowed =  _result.dailyPayPermission.find(e => e === dailyPayType.BET_PAY) ||  _result.dailyPayPermission.find(e => e === dailyPayType.LOTTERY) === 0 ? true : false;
                    let dailyPayCGCreationAllowed = _result.dailyPayPermission.find(e => e === dailyPayType.CG_PAY) ? true : false;
                    let externalGameDailyPayCreationAllowed = _result.dailyPayPermission.find(e => e === dailyPayType.VIDEO_SLOT) ? true : false;
                    let sportDailyPayCreationAllowed = _result.dailyPayPermission.find(e => e === dailyPayType.SPORT) ? true : false;
                    let contractCreationAllowed = _result.contractPermission.find(e => e === ContractType.LOTTERY) === 0 ? true : false;
                    let externalGameContractCreationAllowed = _result.contractPermission.find(e => e === ContractType.VIDEO_SLOT) ? true : false;
                    context.commit(mutationTypes.USER_INFO_PRIVILEGES_BONUS, {
                        contractCreationAllowed: contractCreationAllowed,
                        dailyPayCreationAllowed: dailyPayCreationAllowed,
                        dailyPayCGCreationAllowed: dailyPayCGCreationAllowed,
                        haveContract: _result.haveContract,
                        haveDailyPay: _result.haveDailyPay,
                        haveCGDailyPay: _result.haveCGDailyPay,
                        haveExternalGameContract: _result.haveExternalGameContract,
                        haveExternalGameDailyPay: _result.haveExternalGameDailyPay,
                        dailyPayPermission: _result.dailyPayPermission,
                        contractPermission: _result.contractPermission,
                        externalGameDailyPayCreationAllowed: externalGameDailyPayCreationAllowed,
                        externalGameContractCreationAllowed: externalGameContractCreationAllowed,
                        sportDailyPayCreationAllowed: sportDailyPayCreationAllowed,
                        haveSportGameDailyPay: _result.haveSportGameDailyPay,
                        haveProportionalDividend: _result.haveProportionalDividend,
                        haveBonusWallet: _result.haveBonusWallet
                    });
                }
                catch (err) {
                    console.error(err);
                }
            }
        };
        this.mutations[mutationTypes.USER_INFO_PRIVILEGES_BONUS] = (state, payload) => {
            state.privileges.contractCreationAllowed = payload.contractCreationAllowed;
            state.privileges.dailyPayCreationAllowed = payload.dailyPayCreationAllowed;
            state.privileges.dailyPayCGCreationAllowed = payload.dailyPayCGCreationAllowed;
            state.privileges.haveContract = payload.haveContract;
            state.privileges.haveExternalGameContract = payload.haveExternalGameContract;
            state.privileges.haveDailyPay = payload.haveDailyPay;
            state.privileges.haveCGDailyPay = payload.haveCGDailyPay;
            state.privileges.haveExternalGameDailyPay = payload.haveExternalGameDailyPay;
            state.privileges.dailyPayPermission = payload.dailyPayPermission;
            state.privileges.contractPermission = payload.contractPermission;
            state.privileges.externalGameDailyPayCreationAllowed = payload.externalGameDailyPayCreationAllowed;
            state.privileges.externalGameContractCreationAllowed = payload.externalGameContractCreationAllowed;
            state.privileges.sportDailyPayCreationAllowed = payload.sportDailyPayCreationAllowed,
            state.privileges.haveSportGameDailyPay = payload.haveSportGameDailyPay,
            state.privileges.haveProportionalDividend = payload.haveProportionalDividend,
            state.privileges.haveBonusWallet = payload.haveBonusWallet;
        };
    }
}